import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from "react-router-dom";
import LobbyContent from '../LobbyContent/LobbyContent';
import InformationMoDesign from '../LobbyContent/MobileDesign/InformationMoDesign/InformationMoDesign';
import NotificationMoDesign from '../LobbyContent/MobileDesign/NotificationMoDesign';
import StatementMoDesign from '../LobbyContent/MobileDesign/StatementMoDesign';
import DreamBookPopup from '../Header/HeaderRightMenu/DreamBookPopup';
import { useDispatch, useSelector } from 'react-redux';
import { setCommonConfig } from '../../redux/actions';
import { makeAjax, url, respStatus, showMessage } from '../../helpers/global_helper';
import Promotion from "../Header/HeaderRightMenu//Promotion";

const NavigationComponent = ({ setSidebarVisible }) => {
  const location = useLocation();
  const dispatch = useDispatch();

  const country = localStorage.getItem("activeGameId")
  const gameId = useSelector((state) => state.CommonConfig.gameId);
  const gameType = useSelector((state) => state.CommonConfig.gameType) ?? "4d3d2d";
  const gameID = country ? country : gameId
  const country_name = useSelector((state) => state.CommonConfig.country_name);

  React.useEffect(() => {
    if (location.pathname === '/result' || location.pathname === '/information' || location.pathname === '/statement' || location.pathname === '/notification' || location.pathname === '/promotion') {
      setSidebarVisible(false);
    } else {
      setSidebarVisible(true);
    }
  }, [location, setSidebarVisible]);

  useEffect(() => {
    makeAjax(url.TOGEL_API.getTogelDetails, { "gameId": gameID, "gameType": gameType }).then((response) => {
      if (response.status !== respStatus["SUCCESS"]) {
        showMessage(response);
        return;
      }
      dispatch(setCommonConfig({ key: 'discount', value: response.data }));
    })
  }, [country_name, gameId, gameType])

  return (
    <div className='navigational-wrapper'>
      <Routes>
        <Route path="/game/:game_code" element={<LobbyContent />} />
        <Route path="*" element={<LobbyContent />} />
        <Route path="/result" element={<LobbyContent />} />
        <Route path="/information" element={<InformationMoDesign />} />
        <Route path="/notification" element={<NotificationMoDesign />} />
        <Route path="/statement" element={<StatementMoDesign />} />
        <Route path='/dreambook' element={<DreamBookPopup />} />
        <Route path="/promotion" element={<Promotion />} />
      </Routes>

    </div>
  );
};

export default NavigationComponent;
